import { ValidationResult } from "nutso";

const success: ValidationResult = { isValid: true, errorMessage: "", errorPath: [] };

export const validationUtils = {
  success,
};
